import { inject } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { Preferences } from '@capacitor/preferences';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

export const routeGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean> => {
  const authService = inject(AuthService);
  const isAuthenticated = await authService.isAuthenticated();

  if (isAuthenticated) return true;

  const redirectPath = state.url;
  await Preferences.set({
    key: 'REDIRECT_LOCATION',
    value: redirectPath,
  });
  authService.goToLogin(route.queryParams);
  return false;
};
